var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36013 10.5603H8.02289V20.6138H3.36013C3.15403 20.6138 2.95636 20.5323 2.81062 20.3873C2.66488 20.2423 2.58301 20.0456 2.58301 19.8405V11.3336C2.58301 11.1285 2.66488 10.9318 2.81062 10.7868C2.95636 10.6418 3.15403 10.5603 3.36013 10.5603V10.5603Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02283 10.5604L11.9085 2.8269C12.3167 2.8269 12.7209 2.90692 13.098 3.06237C13.4752 3.21783 13.8178 3.44569 14.1065 3.73294C14.3952 4.02018 14.6241 4.3612 14.7803 4.7365C14.9366 5.11181 15.017 5.51406 15.017 5.92029V8.24033H21.0276C21.248 8.24033 21.4658 8.28697 21.6667 8.37715C21.8676 8.46734 22.0469 8.599 22.1928 8.76342C22.3386 8.92783 22.4477 9.12123 22.5127 9.33078C22.5777 9.54033 22.5972 9.76125 22.5698 9.97887L21.4042 19.259C21.3572 19.6331 21.1745 19.9772 20.8905 20.2267C20.6065 20.4762 20.2407 20.6139 19.8619 20.6139H8.02283",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.bca0692e61329783ccd8995dd9a4e90e.svg";
export { ForwardRef as ReactComponent };